import { gql } from '@apollo/client';

export const DELETE_FRAMEWORKRESULT = gql`
  mutation deleteFrameworkResult($id: ID!) {
    frameworkResult: deleteFrameworkResult(id: $id) {
      id
    }
  }
`;
